import {
  getCountry,
  setCustomerProfileTag,
} from '../../components/product-samples/set-customer-tag';


const Account = () => {
  // Fallback
  if (!document.querySelector('.account-dashboard')) {
    return false;
  }

  // Els
  const els = {
    mobileMenu: '#customer-account-mobile-menu',
  };

  // Execute Functions
  $(document).ready(function () {
    $(els.mobileMenu).on('change', function () {
      mobileNaivation($(this).val());
    });
    document.querySelector('.reorder-button').addEventListener('click', function () {
      const execute = () => {
        setTimeout(() => {
          const modal = document.querySelector('#advance-reorder-model');
          if (modal) {
            const propertiesInput = document.querySelector('#advance-reorder-model input[name="product_properties"]');
            if (!propertiesInput) return;
            const properties = JSON.parse(propertiesInput.value);
            const samples = Object.entries(properties).map(([key, value]) => {
              return value.some((property) => property.name === '_sample' && property.value === 'true') ? key : null;
            }).filter((sample) => sample);
            if (!samples.length) return;
            const button = document.querySelector(`#advance-reorder-model .reorder-addtocart`);
            const button2 = document.querySelector(`#advace_popup_reorder`);

            samples.forEach((sample) => {
              const input = document.querySelector(`#advance-reorder-model input[data-variant="${sample}"]`);
              if (input) {
                // input.remove();
                input.setAttribute('disabled', 'disabled');
                if (input.checked) {
                  input.click();
                  input.checked = false;
                }
                const id = input.getAttribute('data-id');
                const counter = document.querySelector(`#advance-reorder-model .prod-qty-val${id}`);
                if (counter) {
                  counter.value = 0;
                  counter.setAttribute('disabled', 'disabled');
                }
              }
              if (button) {
                const items = button.value.split(',');
                const newItems = items.filter((item) => !item.includes(sample)).join(',');
                button.value = newItems;
                button2.value = newItems;
                if (!newItems) {
                  button.setAttribute('disabled', 'disabled');
                  button2.setAttribute('disabled', 'disabled');
                }
              }
            });
          } else {
            execute();
          }
        }, 1000);
      };
      execute();
    });
  });

  // click on "update information" button
  $("#update_information_button").click(function(){

    const id = $("#customer-id").val();
    const tag = $("#account-dashboard__update-gender_select").val();

    setCustomerProfileTag({
      country: getCountry(),
      tag: tag,
      id: id
    }).then(res => res.json()).then(data => {
      if (data.statusCode == 200) {        
        $("#update-gender-select").css("display", "none");
        $("#update_information_button").css("display","none");
        $("#selected-gender").html(tag);
        $("#update-gender-selected").css("display","block");
        $("#if-show-selected").css("display","block");
      } else {
        // response error         
        console.error("selected tag name is unavailable, API return isn't 200");          
        $("#update-gender-select .nice-select").addClass("error");
        $(".selectbox-error-icon").css("display","block");
      }        
    });

  });

  // click on "edit" button
  $("#update-gender-edit").click(function(){
    $("#update-gender-select").css("display", "block");
    $("#update-gender-selected").css("display","none");
    $("#update_information_button").css("display","block");
    $("#update-gender-select .nice-select").removeClass("error");
    $(".selectbox-error-icon").css("display","none");
  });


  /**
   * Mobile Navigation
   */
  function mobileNaivation(url) {
    // Scroll To on Mobile
    if (window.location.pathname == '/account' && url.indexOf('#') != -1) {
      let anchor = url.split('#')[1];
      let container = $(anchor);
      let scrollTop = container.offset().top - 20; // Add Spacing
      anchor = `#${anchor}`;

      setTimeout(() => {
        window.location.href = hash;
        window.scrollTo({ top: scrollTop, behavior: 'smooth' });
      }, 250);
    } else {
      window.location = url;
    }
  }
};

export default Account;
